import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { onAuthStateChanged } from '../services/auth';
import store from '../store';
import { onUserAuth } from '../store/reducers/user';

const AuthProvider = () => {
  const [loadingUser, setUserLoading] = useState(true);

  useEffect(
    () =>
      onAuthStateChanged(async (user) => {
        try {
          setUserLoading(true);
          await store.dispatch(onUserAuth(user));
          setUserLoading(false);
        } catch {
          setUserLoading(false);
        }
      }),
    []
  );
  return loadingUser ? null : <Outlet />;
};
export default AuthProvider;
